/** Extract handle from URL, @handle, or bare username. */
export function instagramHandle(raw) {
  if (!raw) return "";
  let s = String(raw).trim();
  if (!s) return "";

  const fromUrl = s.match(/instagram\.com\/([^/?#]+)/i);
  if (fromUrl) s = fromUrl[1];

  return s.replace(/^@/, "").replace(/\/$/, "");
}

/** Form input value: bare handle (UI shows a leading @). */
export function instagramHandleForInput(stored) {
  return instagramHandle(stored);
}

/** Display label: @handle */
export function formatInstagramHandle(raw) {
  const handle = instagramHandle(raw);
  return handle ? `@${handle}` : null;
}

/** Normalize to a full https URL for storage and links. */
export function normalizeInstagramUrl(raw) {
  const handle = instagramHandle(raw);
  if (!handle) return null;
  return `https://instagram.com/${handle}`;
}

/** Safe href for event/profile links (handles legacy bare handles). */
export function instagramHref(raw) {
  return normalizeInstagramUrl(raw);
}
